import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function summarySubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  page12Overlay: Ref<boolean>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void,
  getProductStepFromBackend: (
    forward: boolean,
    backward: boolean,
    resume: boolean,
    autoPopulated: boolean,
    summaryEditBtn: string,
  ) => void,
  resumeBundleType: Ref<string>,
): void {
  isTimeOut.value = false;
  page12Overlay.value = true;
  const requestModel2 = {
    dropOffStep: "S13",
    webFormRequestId: ccFormValue.value.webFormRequestId,
    summary: "true",
  };
  MasterService.pageSubmit(requestModel2, ccFormValue.value.token)
    .then((res) => {
      if (res.status == 200) {
        isTimeOut.value = true;
        page12Overlay.value = false;
        ccFormValue.value.dropOffStep = 9;
        //TODO-Matrix
        if (
          prop.type == "PF_CC" ||
          prop.type == "EP_CC" ||
          resumeBundleType.value == "PF_CC" ||
          resumeBundleType.value == "EP_CC"
        ) {
          getProductStepFromBackend(true, false, false, false, "");
        } else {
          jumpStep(13, "", "12");
        }
      } else {
        page12Overlay.value = false;
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
      page12Overlay.value = false;
    });
}
